import { Injectable } from '@angular/core';
import { io, Socket } from 'socket.io-client';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SocketService {
  private socket!: Socket;
  private readonly SERVER_URL = environment.API_ENDPOINT; // Make sure this matches your backend port

  constructor() {
    this.socket = io(this.SERVER_URL);
  }

  listen<T>(eventName: string): Observable<T> {
    return new Observable((subscriber) => {
      this.socket.on(eventName, (data:T) => {
        subscriber.next(data);
      });
    });
  }

  emit<T>(eventName: string, data: T): void {
    this.socket.emit(eventName, data);
  }
}
